import React from 'react';

import "./firstwhite.css";

function Firstwhite() {
  return (
    <div className='white1'>
        <div className='textwhite'>

mentions and accolades
<br/>
        </div>

<div className='mimage'>
<img src="marqeimage.png"/>


<img src="marqeimage.png" style={{marginLeft:"110px"}}/>

</div>



    </div>
  )
}

export default Firstwhite